<!-- @switch (dialogData?.isForm)
  @case true
    <mat-dialog-title>{{ message }}</mat-dialog-title>

    <mat-dialog-content>
      @if (dialogData.formFieldType === FormValueTypeEnum.TEXT)
        <mat-form-field appearance="outline" class="material-form" [formGroup]="formGroup">
          <mat-label>{{ dialogData.placeholder ?? 'Content / Comment' }}</mat-label>
          <textarea
            autocomplete="off"
            formControlName="content"
            matInput
            #contentInput
            maxlength="250"
            rows="3">
          </textarea>
          <mat-hint align="end">{{ contentInput?.value?.length }}/250</mat-hint>
        </mat-form-field>
      @end

      @if (dialogData.formFieldType === FormValueTypeEnum.NUMBER || dialogData.formFieldType === FormValueTypeEnum.AMOUNT)
        <mat-form-field appearance="outline" class="material-form" [formGroup]="formGroup">
          <mat-label>{{ dialogData.placeholder ?? 'Value' }}</mat-label>
          <input autocomplete="off" formControlName="content" matInput type="number" />
        </mat-form-field>
      @end

      @if (dialogData.formFieldType === FormValueTypeEnum.EMAIL)
        <mat-form-field appearance="outline" class="material-form" [formGroup]="formGroup">
          <mat-label>{{ dialogData.placeholder ?? 'E-mail Address' }}</mat-label>
          <input autocomplete="off" formControlName="content" matInput type="email" />
        </mat-form-field>
      @end
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      @for (data of buttons; track data)
        <button
          [mat-dialog-close]="data.value ? formGroup.get('content')?.value : null"
          mat-raised-button
          class="rounded-3 text-white {{ data?.value ? 'bg-primary' : 'bg-danger' }}">
          {{ data?.title }}
        </button>
      @end
    </mat-dialog-actions>
  @end

  @default
    <mat-dialog-title>{{ title ?? 'Confirm' }}</mat-dialog-title>

    <mat-dialog-content>
      {{ message ?? 'Are you sure you want to save?' }}
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      @for (data of buttons; track data)
        <button
          [mat-dialog-close]="data.value"
          mat-raised-button
          class="rounded-3 text-white {{ data?.value ? 'bg-primary' : 'bg-danger' }}">
          {{ data?.title }}
        </button>
      @end
    </mat-dialog-actions>
  @end
@end -->

<mat-dialog-content>{{dialogData().message}}</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button mat-dialog-close="false">Cancel</button>
  <button class="confirm" mat-button color="primary" mat-dialog-close="true">Yes</button>
</mat-dialog-actions>